import { render, staticRenderFns } from "./examaudiocmponent.vue?vue&type=template&id=4b1cfa9a"
import script from "./examaudiocmponent.vue?vue&type=script&lang=js"
export * from "./examaudiocmponent.vue?vue&type=script&lang=js"
import style0 from "./examaudiocmponent.vue?vue&type=style&index=0&id=4b1cfa9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports